import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="gecko-snap--file-upload"
export default class extends Controller {
  static targets = ["input", "previewContainer"]

  connect() {
    this.inputTarget.click()
    this.inputTarget.addEventListener("change", (event) => {
      Array.from(event.target.files).forEach(file => {

        let thumbnail = document.createElement("div")
        thumbnail.setAttribute('class', 'd-inline-block me-2')

        let preview = document.createElement("img")
        preview.setAttribute('class', 'img-thumbnail')
        preview.setAttribute('style', 'max-height:140px')

        let reader = new FileReader()
        reader.onload = (e) => {
          preview.src = e.target.result
          thumbnail.appendChild(preview)
          this.previewContainerTarget.appendChild(thumbnail)
        }
        reader.readAsDataURL(file)
      })
    })
  }
}
